import { FullFormState } from "../Store/FullFormState";
import { FullFormAction } from "../Store/FullFormAction";

import { ModalStateActionType } from "./FormModalAction";

export function ModalStateReducer(state: FullFormState, action: FullFormAction): FullFormState {
    switch (action.type) {
        case ModalStateActionType.ShowModal: {
            return {
                ...state,
                modalState: {
                    ...action.payload,
                    isOpen: true,
                },
            };
        }
        case ModalStateActionType.CloseModal: {
            return {
                ...state,
                modalState: undefined,
            };
        }
        default:
            return state;
    }
}
